import styled from 'styled-components';

import i18n, { AppLangs } from '../i18n';
import { FontSize } from '../theme/FontSize';
import {
  Drawer as AntdDrawer,
  DrawerProps as AntdDrawerProps,
} from '../utils/local-antd';

const StyledDrawer = styled(AntdDrawer)`
  &.ant-drawer-content {
    background-color: ${({ theme }) => theme.bgCanvas};
  }

  .ant-drawer-close svg {
    fill: ${({ theme }) => theme.fgPrimary};
  }

  .ant-drawer-title {
    color: ${({ theme }) => theme.fgPrimary};
    font-size: ${FontSize.l};
  }

  .ant-drawer-header {
    border-bottom-color: ${({ theme }) => theme.fgPrimary};
  }
`;

type DrawerProps = AntdDrawerProps;

export const Drawer: React.FC<DrawerProps> = ({ children, ...props }) => {
  const lang = i18n.language as AppLangs;

  return (
    <StyledDrawer
      placement={lang === AppLangs.AR ? 'left' : 'right'}
      {...props}
    >
      {children}
    </StyledDrawer>
  );
};
